import * as React from 'react'
import { connect } from 'react-redux'
import { Text, Spacing, StackChildren } from '@doordash/design-language'
import t from './strings'
import Button from '@doordash/component-button'
import { IDV_FAQ_URL } from '../../../constants'
import { loadUrl } from '../../../webview'
import { FAQLink } from './styles'
import {
  EventActions,
  IdentityVerificationPages,
} from '../../../typeModules/events'
import * as events from '../../../events'

type Props = {
  trackIdentityVerificationSteps: (data: any) => any
}

const IdvNeedsReview: React.FC<Props> = ({
  trackIdentityVerificationSteps,
}) => {
  React.useEffect(() => {
    trackIdentityVerificationSteps({
      status: EventActions.Rendered,
      step: IdentityVerificationPages.NeedsReview,
    })
  }, [trackIdentityVerificationSteps])

  return (
    <StackChildren size={Spacing.Large}>
      <Text styles={Text.Styles.MajorPageTitle}>{t.idvNeedsReview()}</Text>
      <Text styles={Text.Styles.PageDescriptionBody}>
        {t.idvNeedsReviewSubtext()}
      </Text>
      <Text styles={Text.Styles.PageDescriptionBody}>
        {t.idvFailureSubtext2()}{' '}
        <FAQLink href={IDV_FAQ_URL} target="_blank">
          {t.idvFailureFAQ()}
        </FAQLink>{' '}
        {t.idvFailureSubtext3()}
      </Text>
      {
        <Button
          href={IDV_FAQ_URL}
          tag="a"
          target="_blank"
          onClick={() => loadUrl(IDV_FAQ_URL)}
        >
          {t.viewFAQ()}
        </Button>
      }
    </StackChildren>
  )
}

const mapDispatchToProps = {
  trackIdentityVerificationSteps: events.trackIdentityVerificationSteps,
}

export default connect(null, mapDispatchToProps)(IdvNeedsReview)
